// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2zwYRSUs9Pj4DESLgVppk0","icon":"_2hzIYYoYQ_5XkkRFgsAMSs","active":"_1TS6dpPgc68bkP3HgSOWJp"};